<template>
  <div class="about">
    <!-- DESCRIÇÃO -->
    <div class="jumbotron py-4">
      <h1 class="display-4 text-center pb-4">Quem somos</h1>
      <b-container>
        <p class="lead">
          O Centro Potiguar de Geociências - CPGeo é uma empresa especializada
          no processamento de dados sísmicos, com foco voltado para a Exploração
          e Produção de óleo e gás.
        </p>
        <hr class="my-4" />
        <p>
          Aplicamos nossa experiência acumulada em mais de 35 anos na Petrobras
          para desenvolver projetos de processamento sísmico, com atenção
          especial para as bacias do Parnaíba, Solimões, Amazonas, Acre,
          Potiguar, Sergipe-Alagoas, Recôncavo, Tucano, Espírito Santo, São
          Francisco e Paraná.
        </p>
      </b-container>
    </div>
    <!-- HISTÓRIA -->
    <b-container class="pb-4 text-justify">
      <h3 class="text-center pb-2">História</h3>
      <p>
        O CPGeo desenvolve vários projetos na área de Processamento de Dados
        Sísmicos desde a sua criação no ano de 2007, em especial no onshore
        brasileiro.
      </p>
      <p>
        Desde então já processamos mais de 130.000 km de dados sísmicos 2D e
        mais de 3.500 km2 de sísmica 3D, nas mais diferentes bacias, desde a
        Bacia do Paraná até a Bacia do Acre.
      </p>
      <p>
        O CPGeo fornece serviços de processamento de dados sísmicos terrestres e
        marítimos com o objetivo de reduzir o risco dos projetos de E&P.
      </p>
      <p>
        O principal diferencial do CPGeo em relação a outras empresas da área
        deve-se ao desenvolvimento e uso de um sistema próprio e completo para o
        processamento sísmico, denominado HFS.
      </p>
      <p>
        O HFS possibilita processar dados sísmicos desde os sismogramas de campo
        até a migração 3D pré-empilhamento em tempo, passando por todas as
        etapas do fluxograma.
      </p>
      <h3 class="text-center pb-2">Código de ética</h3>
      <p>
        O CPGeo possui Código de Ética assinado por todos os seus sócios
        executivos e empregados.
      </p>
      <p>
        Este Código de Ética e Conduta reúne as principais orientações éticas
        para a condução dos nossos negócios e é aplicável a todos os
        colaboradores de todas as operações. Tem como objetivo assegurar a
        adesão aos princípios e valores éticos e de moralidade corporativa, em
        observância a todas as normas aplicáveis, inclusive aquela que trata da
        prática de atos lesivos contra a administração pública, nacional ou
        estrangeira, introduzida pela Lei n.o 12.846/2013 – Lei Anticorrupção.
      </p>
    </b-container>
    <!-- PERFIS -->
    <b-container fluid class="pb-4">
      <h1 class="display-4 text-center">Conheça nossa equipe</h1>
    </b-container>
    <b-container>
      <b-row cols="1" cols-sm="2" cols-md="2" cols-xl="3" align-h="center">
        <b-col class="mb-4">
          <div class="person text-center">
            <img src="@/assets/about/heron.png" class="rounded-circle mb-5" style="height: 210px" />
            <h3>Heron Schots</h3>
            <p class="subtitle text-muted">Sócio Fundador</p>
            <p class="mb-4">
              Geofísico com mais de 38 anos de experiência, tendo trabalhado na
              Petrobras com aquisição e processamento sísmicos e desenvolvimento
              de softwares. Mestre em Geofísica. Estudou mais de 10 cursos de
              curta duração na Universidade do Texas, abrangendo teoria e
              processamento sísmico com os mais renomados professores de cada
              área. Trabalhou na Petrobras com aquisição, controle de qualidade
              de campo, processamento de dados sísmicos e desenvolvimento de
              softwares. Por vários anos foi professor da Universidade
              Petrobras. Desenvolveu o nosso pacote proprietário de
              processamento denominado <b>HFS</b> e realiza rotineiramente as
              atualizações necessárias para se adequar aos objetivos das
              empresas Contratantes. Possui larga experiência em processamento
              terrestre e marítimo.
            </p>
          </div>
        </b-col>
        <b-col class="mb-4">
          <div class="person text-center">
            <img src="@/assets/about/sergio.png" class="rounded-circle mb-5" style="height: 210px" />
            <h3>Sérgio Freire</h3>
            <p class="subtitle text-muted">Sócio Diretor</p>
            <p class="mb-4">
              Geofísico, tem mais de 38 anos de experiência e com PhD em
              Geofísica pela Universidade Federal da Bahia. Ingressou na
              Petrobras em 1981, tendo assumido as funções de geofísico de
              aquisição sísmica na Bacia Potiguar e geofísico de processamento
              na Bacia do Recôncavo. A partir de 1995 assumiu vários cargos
              gerenciais na Petrobras, com destaque para as áreas de
              Processamento e Interpretação Exploratórias na Bahia e de 2002 a
              2014 na Gerência de Exploração da Bacia de Sergipe-Alagoas. Entre
              2015 e 2018 trabalhou como consultor independente e em 2019
              ingressou no Centro Potiguar de Geociências.
            </p>
          </div>
        </b-col>
        <b-col class="mb-4">
          <div class="person text-center">
            <img src="@/assets/about/andrea.jpeg" class="rounded-circle mb-5" style="height: 210px" />
            <h3>Andréa Oliveira</h3>
            <p class="subtitle text-muted">
              Assistente Administrativa e técnica de seguraça do trabalho
            </p>
            <p class="mb-4">
              Formada pela Universidade Federal do Rio Grande do Norte (UFRN) e
              pelo Centro de Tecnologia Educacional a Distância (CTEAD). Exerce
              a função na empresa a mais de 10 anos, atuando nas áreas de
              secretariado, produção, finanças, RH, logística, contratos e
              segurança do trabalho.
            </p>
          </div>
        </b-col>
        <b-col class="mb-4">
          <div class="person text-center">
            <img src="@/assets/about/daniel.jpg" class="rounded-circle mb-5" style="height: 210px" />
            <h3>Daniel Ferreira</h3>
            <p class="subtitle text-muted">Geofísico</p>
            <p class="mb-4">
              Formado em Geofísica pela Universidade Federal do Pará. Atua desde
              2011 no processamento de dados sísmico 2D e 3D das bacias do Acre,
              do Paraná, do Parnaíba, Potiguar, do São Francisco, de
              Sergipe-Alagoas, do Solimões e do Recôncavo.
            </p>
          </div>
        </b-col>
        <b-col class="mb-4">
          <div class="person text-center">
            <img src="@/assets/about/danilo.jpg" class="rounded-circle mb-5" style="height: 210px" />
            <h3>Danilo Ferreira</h3>
            <p class="subtitle text-muted">Geofísico</p>
            <p class="mb-4">
              Geofísico formado pela Universidade Federal do Pará (UFPA), com
              mais de 10 anos de experiência na área de processamento sísmico em
              tempo 2D/3D e em profundidade 2D de dados terrestres de bacias
              sedimentares brasileiras.
            </p>
          </div>
        </b-col>
        <b-col class="mb-4">
          <div class="person text-center">
            <img src="@/assets/about/rafael.jpg" class="rounded-circle mb-5" style="height: 210px" />
            <h3>Rafael Furtado</h3>
            <p class="subtitle text-muted">Geofísico</p>
            <p class="mb-4">
              Geofísico formado pela Universidade Federal do Pará, com 8 anos de experiência em processamento de dados
              sísmicos terrestres 2D/3D em tempo e 2D em profundidade. Processamento de dados sísmicos das bacias do
              Parnaíba, São Francisco, Potiguar, Tacutu, Amazonas, Solimões e Paraná.
            </p>
          </div>
        </b-col>
        <b-col class="mb-4">
          <div class="person text-center">
            <img src="@/assets/about/hans.png" class="rounded-circle mb-5" style="height: 210px;" />
            <h3>Hans Castro Einsiedler</h3>
            <p class="subtitle text-muted">Geofísico</p>
            <p class="mb-4">
              Formado em geofísica pela Universidade Federal da Bahia (UFBA) através do Programa de Formação de Recursos
              Humanos da ANP (PRH-ANP). Mestrado em geofísica pela Universidade Federal Fluminense (UFF). Tem 6 anos de
              experiencia trabalhando em empresas internacionais com projetos de aquisição e processamento sísmico
              terrestre/marítimo de dados das bacias sedimentares brasileiras. Participação em projetos de aquisição
              sísmica nas bacias sedimentares do Recôncavo, Rio do Peixe, Parecis, Potiguar e São Francisco.
              Processamento sísmico de dados das bacias sedimentares do São Francisco, Parnaíba, Jequitinhonha, Tacutu e
              Santos.
            </p>
          </div>
        </b-col>
        <b-col class="mb-4">
          <div class="person text-center">
            <img src="@/assets/about/erivania.jpeg" class="rounded-circle mb-5" style="height: 210px;" />
            <h3>Erivânia Gomes do Nascimento</h3>
            <p class="subtitle text-muted">Analista de sistemas</p>
            <p class="mb-4">
              Possui graduação em Sistemas de Informação, Tecnologia da Informação na UNIRN, especialização em Redes de
              Computadores, e pós graduação em gestão estratégica em sistemas de informação na UFRN.
            </p>
          </div>
        </b-col>
        <b-col class="mb-4">
          <div class="person text-center">
            <img
              src="@/assets/about/cadu.jpg"
              class="rounded-circle mb-5"
              style="height: 210px;"
            />
            <h3>Carlos Eduardo</h3>
            <p class="subtitle text-muted">Analista de sistemas</p>
            <p class="mb-4">
              Cursando Bacharelado em Tecnologia da Informação na UFRN.
            </p>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <!-- CLIENTES -->
    <b-container class="pb-4 text-center">
      <h1 class="display-4">Clientes</h1>
      <p class="text-justify py-3">
        O Centro Potiguar de Geociências – CPGeo, desde a sua fundação, se
        orgulha de já ter realizado trabalhos para diferentes empresas, dentre
        elas a Eneva, Petrobras, Shell, BP, BGP, Devon, ANP, Geo-Park, Starfish,
        Nova Petróleo, Imetame, Partex, Galp, Ouro Preto, entre outras. Em
        junho/2020, firmamos uma aliança estratégica com a Energy Platform
        (EnP).
      </p>

      <div class="clientes">
        <img src="@/assets/about/empresas/anp.png" alt="Agência Nacional de Petróleo" class="py-2" />
        <img src="@/assets/about/empresas/eneva.png" alt="Eneva" />
        <img src="@/assets/about/empresas/petrobras.png" alt="Petrobras" />
        <img src="@/assets/about/empresas/shell.jpeg" alt="Shell" />
        <img src="@/assets/about/empresas/enp.png" alt="EnP" class="px-2 py-1" />
        <img src="@/assets/about/empresas/bp.jpeg" alt="British Petroleum" />
        <img src="@/assets/about/empresas/geopark.png" alt="GeoPark" class="px-2 py-1" />
        <img src="@/assets/about/empresas/panamerican.jpg" alt="PanAmerican Geophysical" class="px-2" />
        <img src="@/assets/about/empresas/enauta.png" alt="Enauta" class="py-4 px-2" />
        <img src="@/assets/about/empresas/galp.png" alt="Galp" class="px-2 py-2" />
        <img src="@/assets/about/empresas/ufrj.png" alt="Universidade Federal do Rio de Janeiro" class="px-1" />
        <img src="@/assets/about/empresas/imetame.svg" alt="Imetame" />
        <img src="@/assets/about/empresas/georadar.png" alt="Georadar" class="px-1" />
        <img src="@/assets/about/empresas/ouropreto.png" alt="Ouro Preto" class="px-1" />

        <img src="@/assets/about/empresas/cnpc.jpg" alt="CNPC" />
        <img src="@/assets/about/empresas/partex.jpg" alt="CNPC" />
        <img src="@/assets/about/empresas/petrosynergy.png" alt="CNPC" class="py-4" />
        <img src="@/assets/about/empresas/devon.png" alt="CNPC" />
        <img src="@/assets/about/empresas/dommoenergia.png" alt="Dommo energia" class="px-1 py-3" />
        <img src="@/assets/about/empresas/starfish.png" alt="Starfish Oil and Gas" class="px-1 py-3" />
        <img src="@/assets/about/empresas/enp.png" alt="EnP" class="px-2 py-1" />
        <img src="@/assets/about/empresas/novapetroleo.png" alt="CNPC" class="px-1 py-3" />
        <img src="@/assets/about/empresas/utc.png" alt="UTC" class="px-2 py-3" />
        <img src="@/assets/about/empresas/geoseis.jpg" alt="UTC" />
        <img src="@/assets/about/empresas/codemig.png" alt="Companhia de Desenvolvimento Econômico de Minas Gerais"
          class="px-1 py-2" />
        <img src="@/assets/about/empresas/petrorio.png" alt="PetroRio" class="px-1" />
        <img src="@/assets/about/empresas/g3.png" alt="UTC" class="px-1 py-2" />
        <img src="@/assets/about/empresas/global.png" alt="UTC" />
        <img src="@/assets/about/empresas/saexploration.png" alt="UTC" class="px-1 py-2" />
        <img src="@/assets/about/empresas/potassio.png" alt="UTC" class="px-1 py-1" />
        <img src="@/assets/about/empresas/sabre.png" class="py-1" />
        <img src="@/assets/about/empresas/petra.png" class="py-2" />
      </div>
      <!-- <b-img src="@/assets/about/clientes.png" fluid></b-img> -->
    </b-container>
    <Footer />
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style scoped>
.subtitle {
  font-size: 14px;
  color: #b3b3b3;
  text-transform: uppercase;
}

.person h3 {
  font-size: 18px;
}

.clientes {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}

.clientes img {
  height: 70px;
  margin-bottom: 1rem;
}
</style>
